import { MaterialIcon } from 'shared/ui/MaterialIcon';
import classNames from 'classnames';

import type { OnboardingStatus } from '../../model';

import { BadgeIcon } from './BadgeIcon';

interface GenericStepProps {
  status: OnboardingStatus;
  iconName: string;
  text: string;
  isLast?: boolean;
  tooltipText?: string;
}

export function GenericStep({ status, iconName, text, tooltipText, isLast }: GenericStepProps) {
  return (
    <div
      className={classNames(
        'flex w-[536px] border-b  px-[25px] pb-[13px] pt-4',
        isLast ? 'border-transparent' : 'border-slate-100'
      )}
    >
      <div className="flex w-[186px] items-center gap-2">
        <MaterialIcon className="text-base text-slate-900">{iconName}</MaterialIcon>
        <span className="text-sm text-slate-900">{text}</span>
      </div>
      <BadgeIcon
        status={status}
        tooltipText={tooltipText}
      />
      <div className="ml-auto flex w-[149px] justify-center">
        {status === 'done' && <MaterialIcon className="text-[20px] text-deep-green-700">check</MaterialIcon>}
      </div>
    </div>
  );
}
